import { Button, ButtonPriority, Text, TextTypography, } from '@wix/wix-ui-tpa/cssVars';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { TRANSLATIONS_NAMESPACE } from '../../../constants/translations';
import { DATA_HOOKS } from '../data-hooks';
import styles from './form-loading-error.module.scss';
const FormLoadingError = ({ formId, i18n, translations, language = 'en', onError, isRTL, }) => {
    const t = useMemo(() => i18n.getFixedT(language, TRANSLATIONS_NAMESPACE), [language, i18n]);
    useState(() => i18n.addResources(language, TRANSLATIONS_NAMESPACE, translations));
    const isError = useRef(false);
    useEffect(() => {
        if (!isError.current) {
            isError.current = true;
            onError?.(new Error(`Couldn’t load the form: ${formId}`));
        }
        return () => {
            isError.current = false;
        };
    }, [formId, onError]);
    return (React.createElement("div", { className: styles.container, "data-hook": DATA_HOOKS.FORM_VIEWER_NO_FORM_ERROR, dir: isRTL ? 'rtl' : '' },
        React.createElement(Text, { typography: TextTypography.smallTitle }, t?.('error.could-not-load-form.title')),
        React.createElement(Text, { typography: TextTypography.runningText }, t('error.could-not-load-form.description')),
        React.createElement(Button, { className: styles.button, onClick: () => window.location.reload(), priority: ButtonPriority.primary }, t?.('error.could-not-load-form.button.label'))));
};
export default FormLoadingError;
//# sourceMappingURL=form-loading-error.js.map